import React from "react";

export const CEL = {
  "op-koers": "bg-emerald-200 border border-emerald-300",
  rood: "bg-rose-500 border border-rose-600",
  onvolledig: "bg-amber-200 border border-amber-300",
  "geen-call": "border border-dashed border-zinc-400 bg-white",
  "nog-niet": "border border-zinc-300 bg-white",
  "voor-start": "border border-transparent bg-transparent",
};
const STATUS = { "op-koers": "groen", rood: "rood", onvolledig: "onvolledig (cijfers of WOW)", "geen-call": "geen call", "nog-niet": "nog niet gebeld", "voor-start": "vóór de eerste call" };

const statusTekst = (e) => (e.status === "nog-niet" && e.bezig ? "nog niet compleet" : STATUS[e.status]);
export const celTitel = (e) => `Over week ${e.overWeekNr} (call ${e.callLabel}): ${statusTekst(e)}${e.status === "rood" && e.rodeKpis?.length ? ` · ${e.rodeKpis.join(", ")}` : ""}`;

// v10-C2: 13 weken in één strook; kleur plus aria-label/tooltip, dus nooit alleen kleur.
export function Strook({ r, groot = false, testid }) {
  const reeks = r.reeks || [];
  if (!reeks.length) return null;
  return (
    <div data-testid={testid} role="img" aria-label={`${r.roodAantal} van ${reeks.length} weken rood`} className={`flex ${groot ? "gap-1 w-full" : "gap-0.5"}`}>
      {reeks.map((e) => (
        <div key={e.week} className={groot ? "flex-1 min-w-0 flex flex-col items-center gap-1" : ""}>
          <span title={celTitel(e)} data-testid={`${testid}-cel-${e.week}`} data-status={e.status}
            className={`block rounded-[2px] ${CEL[e.status]} ${groot ? "h-7 w-full" : "h-3.5 w-2.5"}`} />
          {groot && <span className="font-mono text-[10px] text-zinc-500">{e.overWeekNr}</span>}
        </div>
      ))}
    </div>
  );
}

export function StrookLegenda({ reeks, vanafLabel }) {
  if (!reeks?.length) return null;
  return (
    <div data-testid="strook-legenda" className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-zinc-500">
      <span className="font-mono">cijfers over week {reeks[0].overWeekNr} → {reeks[reeks.length - 1].overWeekNr}</span>
      {["op-koers", "rood", "onvolledig", "geen-call", "nog-niet"].map((s) => (
        <span key={s} className="inline-flex items-center gap-1"><span className={`inline-block h-3 w-2.5 rounded-[2px] ${CEL[s]}`} />{s === "op-koers" ? `groen: omzet, PK en bijverkoop behaald, en WOW ingevuld en niet Nee${vanafLabel ? ` (vanaf de call van ${vanafLabel}; daarvoor: WOW niet Nee)` : ""}` : STATUS[s]}</span>
      ))}
    </div>
  );
}

export const terugkerendChip = (r) => (
  <span data-testid={`chip-terugkerend-${r.locatie}`} className="text-[10px] font-bold uppercase tracking-wider rounded-full border px-2 py-0.5 bg-rose-50 text-rose-700 border-rose-300">
    Terugkerend · {r.roodAantal} van {r.reeks.length}
  </span>
);

export const roodRegel = (r) => `${r.roodAantal} van ${r.reeks.length} weken rood${r.roodOpRij ? " · 2 op rij" : ""}`;
